import type { TikTokHashtagBreakoutRow } from '../../hooks/useCompetitiveData'

interface HashtagVelocityChartProps {
  breakouts: TikTokHashtagBreakoutRow[]
  title?: string
  emptyMessage?: string
}

function formatViews(value: number): string {
  const rounded = Math.round(value || 0)
  return rounded.toLocaleString('en-US')
}

export default function HashtagVelocityChart({
  breakouts,
  title = 'Hashtag Velocity Breakouts',
  emptyMessage = 'No hashtag breakouts detected.',
}: HashtagVelocityChartProps) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-600">{title}</h3>

      {breakouts.length === 0 ? (
        <div className="mt-3 rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600">{emptyMessage}</div>
      ) : (
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
              <tr>
                <th className="px-3 py-2 text-left font-semibold">Hashtag</th>
                <th className="px-3 py-2 text-left font-semibold">24h Posts</th>
                <th className="px-3 py-2 text-left font-semibold">7d Posts</th>
                <th className="px-3 py-2 text-left font-semibold">Avg Views/Post</th>
                <th className="px-3 py-2 text-left font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {breakouts.map((row) => (
                <tr key={`${row.id}-${row.hashtag}`} className="border-t border-slate-100">
                  <td className="px-3 py-2 text-slate-900">#{row.hashtag.replace(/^#/, '')}</td>
                  <td className="px-3 py-2 text-slate-700">{Math.round(row.post_count_24h || 0)}</td>
                  <td className="px-3 py-2 text-slate-700">{Math.round(row.post_count_7d || 0)}</td>
                  <td className="px-3 py-2 text-slate-700">{formatViews(row.avg_views_per_post)}</td>
                  <td className="px-3 py-2">
                    {row.is_breakout ? (
                      <span className="rounded-full border border-[var(--danger-100)] bg-[var(--danger-50)] px-2 py-0.5 text-xs font-semibold text-[var(--danger-700)]">
                        Breakout
                      </span>
                    ) : (
                      <span className="rounded-full border border-slate-200 bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-600">
                        Stable
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}
